import { render, staticRenderFns } from "./landing-page-alerts.vue?vue&type=template&id=b53384ba&scoped=true"
import script from "./landing-page-alerts.vue?vue&type=script&lang=js"
export * from "./landing-page-alerts.vue?vue&type=script&lang=js"
import style0 from "./landing-page-alerts.vue?vue&type=style&index=0&id=b53384ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53384ba",
  null
  
)

export default component.exports